import { render, staticRenderFns } from "./TopSidebarContact.vue?vue&type=template&id=febd16f2&"
import script from "./TopSidebarContact.vue?vue&type=script&lang=js&"
export * from "./TopSidebarContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports